<app-rc-dialog-wrapper noClose="true">
  <div class="clinic-identified-dialog">
    <div class="clinic-identified-dialog__body">
      <!-- Image -->
      <div class="clinic-identified-dialog__body-thumb">
        <img src="assets/other/bengal_adult.png" alt="Clinic identified" />
      </div>

      <!-- Text -->
      <h3 class="rc-title-gamma" i18n="@@clinic-identified_title">Clinic identified</h3>
      <p class="rc-paragraph">
        <span i18n="@@clinic-identified_desc-account-affiliated">Your account has been affiliated with</span>
        {{ clinicName }} ({{ clinicId }})
      </p>
      <br />
      <p class="clinic-identified-dialog__paragraph rc-paragraph" i18n="@@clinic-identified_desc-contact">
        If this is not the right clinic, please retry or
      </p>
      &nbsp;
      <p
        class="clinic-identified-dialog__paragraph rc-paragraph rc-button__title rc-button__title--link pointer"
        (click)="contact()"
        i18n="@@clinic-identified_action-contact"
      >
        contact your local support.
      </p>
    </div>

    <div class="clinic-identified-dialog__footer">
      <rc-link data-qa="vs-clinic-identified-popin-button-retry" variant="secondary" size="large" (click)="retry()">
        {{ 'action_retry' | translateKey }}
      </rc-link>
      <span class="rc-button__separator" i18n="@@action_separator">or</span>
      <rc-button data-qa="vs-clinic-identified-popin-button-continue" (click)="continue()">
        {{ 'action_accept' | translateKey }}
      </rc-button>
    </div>
  </div>
</app-rc-dialog-wrapper>
